// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as HyperLogger$OrcaPaymentPage from "../hyper-log-catcher/HyperLogger.bs.js";
import * as PaymentHelpers$OrcaPaymentPage from "../Utilities/PaymentHelpers.bs.js";
import * as PmAuthConnectorUtils$OrcaPaymentPage from "../Utilities/PmAuthConnectorUtils.bs.js";

function PlaidSDKIframe(props) {
  let match = React.useState(() => "");
  let setLinkToken = match[1];
  let linkToken = match[0];
  let match$1 = React.useState(() => false);
  let setIsReady = match$1[1];
  let isReady = match$1[0];
  let match$2 = React.useState(() => []);
  let setPmAuthConnectorsArr = match$2[1];
  let pmAuthConnectorsArr = match$2[0];
  let match$3 = React.useState(() => "");
  let setPublishableKey = match$3[1];
  let publishableKey = match$3[0];
  let match$4 = React.useState(() => "");
  let setClientSecret = match$4[1];
  let clientSecret = match$4[0];
  let match$5 = React.useState(() => "");
  let setSdkAuthorization = match$5[1];
  let sdkAuthorization = match$5[0];
  let match$6 = React.useState(() => false);
  let setIsForceSync = match$6[1];
  let isForceSync = match$6[0];
  let logger = React.useMemo(() => HyperLogger$OrcaPaymentPage.make(undefined, {
    TAG: "Elements",
    _0: "Payment"
  }, clientSecret, publishableKey, undefined), [
    publishableKey,
    clientSecret
  ]);
  React.useEffect(() => {
    let handleParentWindowMessage = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let metaData = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(json), "metadata");
      let linkToken = Utils$OrcaPaymentPage.getString(metaData, "linkToken", "");
      if (linkToken.length > 0) {
        setLinkToken(param => linkToken);
        setPmAuthConnectorsArr(param => Utils$OrcaPaymentPage.getArray(metaData, "pmAuthConnectorArray").map(Core__JSON.Decode.string));
        setPublishableKey(param => Utils$OrcaPaymentPage.getString(metaData, "publishableKey", ""));
        setClientSecret(param => Utils$OrcaPaymentPage.getString(metaData, "clientSecret", ""));
        setSdkAuthorization(param => Utils$OrcaPaymentPage.getString(metaData, "sdkAuthorization", ""));
        return setIsForceSync(param => Utils$OrcaPaymentPage.getBool(metaData, "isForceSync", false));
      }
    };
    window.addEventListener("message", handleParentWindowMessage);
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
        "iframeMountedCallback",
        true
      ]]);
    return () => {
      window.removeEventListener("message", handleParentWindowMessage);
    };
  }, []);
  React.useEffect(() => {
    PmAuthConnectorUtils$OrcaPaymentPage.mountAllRequriedAuthConnectorScripts(pmAuthConnectorsArr, authConnector => {
      if (PmAuthConnectorUtils$OrcaPaymentPage.pmAuthNameToTypeMapper(authConnector) === "PLAID") {
        return setIsReady(param => true);
      }
    }, logger);
  }, [pmAuthConnectorsArr]);
  let callbackOnSuccessOfPlaidPaymentsFlow = async () => {
    try {
      let json = await PaymentHelpers$OrcaPaymentPage.retrievePaymentIntent(clientSecret, undefined, publishableKey, logger, "", true, Primitive_option.some(sdkAuthorization));
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      let status = Utils$OrcaPaymentPage.getString(dict, "status", "");
      let return_url = Utils$OrcaPaymentPage.getString(dict, "return_url", "");
      switch (status) {
        case "failed" :
          Utils$OrcaPaymentPage.postFailedSubmitResponse("confirm_payment_failed", "Payment failed. Try again!");
          break;
        case "processing" :
        case "requires_customer_action" :
        case "succeeded" :
          Utils$OrcaPaymentPage.postSubmitResponse(json, return_url);
          break;
        default:
          Utils$OrcaPaymentPage.postFailedSubmitResponse("sync_payment_failed", "Payment is processing. Try again later!");
      }
      return Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
          "fullscreen",
          false
        ]]);
    } catch (exn) {
      return logger.setLogError("Retrieve failed via Plaid", "PLAID_SDK", undefined, undefined, undefined, undefined, "PLAID");
    }
  };
  let initializePlaid = () => window.Plaid.create({
    token: linkToken,
    onSuccess: (publicToken, param) => {
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [
        [
          "isPlaid",
          true
        ],
        [
          "publicToken",
          publicToken
        ]
      ]);
      if (isForceSync) {
        callbackOnSuccessOfPlaidPaymentsFlow();
        return;
      }
    },
    onLoad: () => logger.setLogInfo("Plaid SDK Loaded", "PLAID_SDK", undefined, undefined, undefined, undefined, undefined),
    onExit: param => {
      if (isForceSync) {
        callbackOnSuccessOfPlaidPaymentsFlow();
        return;
      } else {
        return Utils$OrcaPaymentPage.messageParentWindow(undefined, [
          [
            "fullscreen",
            false
          ],
          [
            "isPlaid",
            true
          ],
          [
            "isExited",
            true
          ],
          [
            "publicToken",
            ""
          ]
        ]);
      }
    }
  }).open();
  React.useEffect(() => {
    if (isReady && linkToken.length > 0) {
      initializePlaid();
    }
  }, [
    isReady,
    linkToken,
    logger
  ]);
  return JsxRuntime.jsx("div", {
    className: "PlaidIframe h-screen w-screen bg-black/40 backdrop-blur-sm m-auto",
    style: {
      opacity: "100",
      transition: "opacity .35s ease .1s,background-color 600ms linear"
    }
  });
}

let make = PlaidSDKIframe;

export {
  make,
}
/* react Not a pure module */
